import { render } from "./invoice-list.vue?vue&type=template&id=35bbcb82&scoped=true"
import script from "./invoice-list.vue?vue&type=script&lang=js"
export * from "./invoice-list.vue?vue&type=script&lang=js"

import "./invoice-list.vue?vue&type=style&index=0&id=35bbcb82&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bbcb82"]])

export default __exports__